import React, { useEffect, useState } from "react";
import Header from "../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import { BrowserRouter, Switch, Route, NavLink } from "react-router-dom";
import "../../../../Assets/Styles/AI.scss";
import Employees from "../../../Dashboard/Components/AI/DataImport/Employees";
import Positions from "../../../Dashboard/Components/AI/DataImport/Positions";
import Projects from "../../../Dashboard/Components/AI/DataImport/Projects";
import Activities from "../../../Dashboard/Components/AI/DataImport/Activities";
import Skills from "../../../Dashboard/Components/AI/DataImport/Skills";
import Trainings from "../../../Dashboard/Components/AI/DataImport/Trainings";
import FinalStage from "../../../Dashboard/Components/AI/DataImport/FinalStage";
import { Config } from "../../../../Config";
import axios from "axios";

const DataImport = (props) => {
  const [EmpFilesUploaded, setEmpFilesUploaded] = useState(false);
  const [PosFilesUploaded, setPosFilesUploaded] = useState(false);
  const [GenerateSkillsFor, setGenerateSkillsFor] = useState(null); // "ALL_JPA" | "JPA_WITHOUT_SKILLS" | null (no skill generation)
  const [GenerateJobDescFor, setGenerateJobDescFor] = useState(null); // "ALL" | "WITHOUT_DESCRIPTION_ONLY" | null
  const [GenerateProjectDescFor, setGenerateProjectDescFor] = useState(null); // "ALL" | "WITHOUT_DESCRIPTION_ONLY" | null
  const [GenerateActivityDescFor, setGenerateActivityDescFor] = useState(null); // "ALL" | "WITHOUT_DESCRIPTION_ONLY" | null
  var PosFilesCount = 0;
  var EmplFileCount = 0;

  useEffect(() => {
    checkEmpFilesUpload();
    checkPosFilesUpload();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const checkPosFilesUpload = () => {
    PosFilesCount = 0;
    setPosFilesUploaded(false);
    checkPosFile1();
  };
  const checkEmpFilesUpload = () => {
    EmplFileCount = 0;
    setEmpFilesUploaded(false);
    checkEmpFile1();
  };
  const validateNavigation = (e, Id) => {
    transformIndicator(Id);
  };
  const transformIndicator = (Id) => {
    if (Id === "positions") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(108px)";
    } else if (Id === "employees") {
      document.getElementById("animated-indicator").style.transform = "none";
    } else if (Id === "projects") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(222px)";
    } else if (Id === "activities") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(332px)";
    } else if (Id === "skills") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(444px)";
    } else if (Id === "trainings") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(557px)";
    } else {
      document.getElementById("animated-indicator").style.transform =
        "translateX(666px)";
    }
  };

  // the next 5 functions are only for checking each file upload status in the positions tab
  const checkPosFile1 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "position" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 1);
        PosFilesCount++;

        checkPosFile2();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("PosFilesUploaded", 0);
          checkPosFile2();
        }
      });
  };
  const checkPosFile2 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "job-requirement" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 2);
        PosFilesCount++;
        checkPosFile3();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("PosFilesUploaded", 0);
          checkPosFile3();
        }
      });
  };
  const checkPosFile3 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "position-salary" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 3);
        PosFilesCount++;
        checkPosFile4();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("PosFilesUploaded", 0);
          checkPosFile4();
        }
      });
  };

  const checkPosFile4 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "position-assignment" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 4);
        PosFilesCount++;
        checkPosFile5();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("PosFilesUploaded", 0);
          checkPosFile5();
        }
      });
  };

  const checkPosFile5 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "position-relation" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        PosFilesCount++;
        if (PosFilesCount === 5) {
          window.localStorage.setItem("PosFilesUploaded", 1); //1:true, 0:false
          setPosFilesUploaded(true);
        } else {
          window.localStorage.setItem("PosFilesUploaded", 0); //1:true, 0:false
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("PosFilesUploaded", 0);
        }
      });
  };

  const checkEmpFile1 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "employee" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 1);
        EmplFileCount++;
        checkEmpFile2();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("EmpFilesUploaded", 0);
          checkEmpFile2();
        }
      });
  };
  const checkEmpFile2 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "employee-salary" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 2);
        EmplFileCount++;
        checkEmpFile3();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("EmpFilesUploaded", 0);
          checkEmpFile3();
        }
      });
  };
  const checkEmpFile3 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "employee-higher-education" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 3);
        EmplFileCount++;
        checkEmpFile4();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("EmpFilesUploaded", 0);
          checkEmpFile4();
        }
      });
  };
  const checkEmpFile4 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "employee-int-work-hist" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 4);
        EmplFileCount++;
        checkEmpFile5();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("EmpFilesUploaded", 0);
          checkEmpFile5();
        }
      });
  };
  const checkEmpFile5 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "employee-language" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 5);
        EmplFileCount++;
        checkEmpFile6();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("EmpFilesUploaded", 0);
          checkEmpFile6();
        }
      });
  };

  const checkEmpFile6 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        "employee-ext-work-hist" +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res, 6);
        EmplFileCount++;
        checkEmpFile7();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("EmpFilesUploaded", 0);
          checkEmpFile7();
        }
      });
  };

  const checkEmpFile7 = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.DataImportURL + "/api/user/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        EmplFileCount++;
        console.log(Res);
        if (EmplFileCount === 7) {
          window.localStorage.setItem("EmpFilesUploaded", 1); //1:true, 0:false
          setEmpFilesUploaded(true);
        } else {
          window.localStorage.setItem("EmpFilesUploaded", 0); //1:true, 0:false
        }
      })

      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 404) {
          window.localStorage.setItem("EmpFilesUploaded", 0);
        }
      });
  };

  return (
    <BrowserRouter basename="/home/dataImport/">
      <div className="main-content security-settings ai">
        <Header PageName={translateText("data_import")} />
        <div className="content-header">
          <div className="address">
            <p>AI</p>
            <img src={Circle} alt="." />
            <p>{translateText("data_import")}</p>
          </div>
        </div>
        <div className="actions navigator navigator-large">
          <span id="animated-indicator"></span>
          <NavLink
            onClick={(e) => validateNavigation(e, "employees")}
            activeClassName="active-nav-node"
            exact
            id="employees"
            to="/"
          >
            <p>{translateText("employees")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "positions")}
            activeClassName="active-nav-node"
            to="/positions"
            id="positions"
          >
            <p>{translateText("positions")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "projects")}
            activeClassName="active-nav-node"
            id="projects"
            to="/projects"
          >
            <p>{translateText("projects")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "activities")}
            activeClassName="active-nav-node"
            to="/activities"
            id="activities"
          >
            <p>{translateText("activities")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "skills")}
            activeClassName="active-nav-node"
            id="skills"
            to="/skills"
          >
            <p>{translateText("skills")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "trainings")}
            activeClassName="active-nav-node"
            to="/trainings"
            id="trainings"
          >
            <p>{translateText("trainings")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "finalStage")}
            activeClassName="active-nav-node"
            id="finalStage"
            to="/finalStage"
          >
            <p>{translateText("final_stage")}</p>
          </NavLink>
        </div>
        <Switch>
          <Route path="/positions" exact>
            <Positions
              CheckEmpFilesUpload={() => checkEmpFilesUpload()}
              CheckPosFilesUpload={() => checkPosFilesUpload()}
              LangData={props.LangData}
              GenerateJobDescFor={GenerateJobDescFor}
              SetGenerateJobDescFor={(Value) => setGenerateJobDescFor(Value)}
            />
          </Route>
          <Route path="/projects" exact>
            <Projects
              LangData={props.LangData}
              GenerateProjectDescFor={GenerateProjectDescFor}
              SetGenerateProjectDescFor={(Value) =>
                setGenerateProjectDescFor(Value)
              }
            />
          </Route>
          <Route path="/activities" exact>
            <Activities
              LangData={props.LangData}
              GenerateActivityDescFor={GenerateActivityDescFor}
              SetGenerateActivityDescFor={(Value) =>
                setGenerateActivityDescFor(Value)
              }
            />
          </Route>
          <Route path="/skills" exact>
            <Skills
              LangData={props.LangData}
              SetGenerateSkillsFor={(Value) => setGenerateSkillsFor(Value)}
              GenerateSkillsFor={GenerateSkillsFor}
            />
          </Route>
          <Route path="/trainings" exact>
            <Trainings LangData={props.LangData} />
          </Route>
          <Route path="/finalStage" exact>
            <FinalStage
              CheckEmpFilesUpload={() => checkEmpFilesUpload()}
              CheckPosFilesUpload={() => checkPosFilesUpload()}
              EmpFilesUploaded={EmpFilesUploaded}
              PosFilesUploaded={PosFilesUploaded}
              LangData={props.LangData}
              GenerateSkillsFor={GenerateSkillsFor}
              GenerateJobDescFor={GenerateJobDescFor}
              GenerateProjectDescFor={GenerateProjectDescFor}
              GenerateActivityDescFor={GenerateActivityDescFor}
            />
          </Route>
          <Route path="/" exact>
            <Employees
              CheckEmpFilesUpload={() => checkEmpFilesUpload()}
              CheckPosFilesUpload={() => checkPosFilesUpload()}
              LangData={props.LangData}
            />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};
export default DataImport;
